import React, { Component } from "react";
import { connect } from "react-redux";

import { getLoggedInUser } from "../helpers/authUtils";
import CrudBar from "../gb-components/CrudBar";
import IconEdit from '../assets/svg/ic-contact-edit.svg';
import IconCalendar from '../assets/svg/ic-actions-calendar.svg';
import IconTrash from '../assets/svg/ic-actions-trash.svg';
import IconSearch from '../assets/svg/ic-actions-search.svg';
import ModalComponent from "../components/Modal";

import AddPacienteFila from '../Views/FilaProcedimentos/cadastro.js'
import PreLoaderWidget from "../components/Loader";
import { Col, DropdownItem, Row } from "reactstrap";
import { getFilasOpened, getFilasStatus } from "../Libs/filaProcedimentos.js";
import DataFila from "../Views/FilaProcedimentos/dataFila.js";
import RecusaFila from "../Views/FilaProcedimentos/recusaFila.js";
import { FilaProcedimentoEnum } from "../helpers/enums.js";
import Select from 'react-select';
import moment from "moment";
import DadosFila from "../Views/FilaProcedimentos/dadosFila.js";
import ImportacaoTabelas from "../Views/FilaProcedimentos/ImportacaoTabelas.js";
import CustomDropdown from "../components/CustomDropdown.js";
import { Link } from 'react-router-dom';

const tiposFiltro = [
  { label: FilaProcedimentoEnum.Aguardando, value: FilaProcedimentoEnum.Aguardando },
  { label: FilaProcedimentoEnum.ProcedimentoAgendado, value: FilaProcedimentoEnum.ProcedimentoAgendado },
  { label: FilaProcedimentoEnum.Recusado, value: FilaProcedimentoEnum.Recusado },
];

class FilaProcedimentos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: getLoggedInUser(),
      pacientes: [],
      pacientesShow: [],
      modalPacienteFila: false,
      modalDataFila: false,
      modalRecusa: false,
      modalDetalhe: false,
      modalImport: false,
      editId: null,
      loading: true,
      secretaria: null,
      filtroData: {
        dt_i: moment().startOf('month').format("YYYY-MM-DD"),
        dt_f: moment().endOf('month').format("YYYY-MM-DD"),
      },
      filtroSituacao: { label: FilaProcedimentoEnum.Aguardando, value: FilaProcedimentoEnum.Aguardando },
      filtroPaciente: ''
    };
    this.openCadastro = this.openCadastro.bind(this);
  }

  async buscarFilaAbertos() {
    this.setState({ loading: true })
    // if (this.props.secretariaSelecionada) {
    if (this.state.user.secretaria) {
      const pacientes = await getFilasOpened(this.state.user.secretaria)
      // aqui é calculado a sequencia do paciente na fila de acordo com o procedimento
      const pacGrouped = this.groupProc(pacientes)

      this.setState({
        pacientes: pacGrouped,
        pacientesShow: pacGrouped,
        loading: false,
        secretaria: this.state.user.secretaria
      })
    }
  }

  async buscarFilaAgendados() {
    this.setState({ loading: true })
    const pacientes = await getFilasStatus(
      FilaProcedimentoEnum.ProcedimentoAgendado,
      this.state.user.secretaria,
      this.state.filtroData.dt_i,
      this.state.filtroData.dt_f,
    )
    // aqui é calculado a sequencia do paciente na fila de acordo com o procedimento
    const pacGrouped = this.groupProc(pacientes)
    // console.log(pacGrouped)

    this.setState({
      pacientes: pacGrouped,
      pacientesShow: pacGrouped,
      loading: false,
    })
  }

  async buscarFilaRecusados() {
    this.setState({ loading: true })
    const pacientes = await getFilasStatus(
      FilaProcedimentoEnum.Recusado,
      this.state.user.secretaria,
      this.state.filtroData.dt_i,
      this.state.filtroData.dt_f,
    )
    // aqui é calculado a sequencia do paciente na fila de acordo com o procedimento
    const pacGrouped = this.groupProc(pacientes)

    this.setState({
      pacientes: pacGrouped,
      pacientesShow: pacGrouped,
      loading: false,
    })
  }

  groupProc(pacientes) {
    function procCallback({ procedimento }) {
      return procedimento.codigo;
    }

    const grouped = Object.groupBy(pacientes, procCallback);
    let procGroups = Object.entries(grouped).map(([k, v]) => {
      return { procedimento: `${v[0].procedimento.codigo} - ${v[0].procedimento.descricao}`, dados: v }
    })

    for (let index = 0; index < procGroups.length; index++) {
      procGroups[index].dados = procGroups[index].dados.sort((a, b) => a.data_fila > b.data_fila ? 1 : -1)

      for (let i2 = 0; i2 < procGroups[index].dados.length; i2++) {
        procGroups[index].dados[i2].seq = i2 + 1;
      }
    }
    // console.log(procGroups)
    return procGroups
  }

  async componentDidMount() {
    console.log(this.state.user.secretaria)
    await this.buscarFilaAbertos();
  }

  openCadastro(item) {
    this.setState({ modalPacienteFila: true, editId: item });
  }

  openSetData(item) {
    this.setState({ modalDataFila: true, editId: item });
  }

  openRecusaModal(item) {
    this.setState({ modalRecusa: true, editId: item });
  }

  openDetalheModal(item) {
    this.setState({ modalDetalhe: true, editId: item });
  }

  closeModal = () => {
    this.setState({
      editId: null,
      modalPacienteFila: false,
      modalDataFila: false,
      modalRecusa: false,
      modalDetalhe: false,
      modalImport: false
    })
  }

  closeModalReload = () => {
    this.setState({
      editId: null,
      modalPacienteFila: false,
      modalDataFila: false,
      modalRecusa: false,
      modalImport: false,
      filtroSituacao: { label: FilaProcedimentoEnum.Aguardando, value: FilaProcedimentoEnum.Aguardando },
      filtroPaciente: ''
    })
    this.buscarFilaAbertos();
  }

  setFiltroSituacao(fil) {
    this.setState({
      filtroSituacao: fil,
    })
    this.carregar(fil.value)
  }

  carregar(situacao) {
    console.log(this.state.filtroSituacao)
    switch (situacao) {
      case FilaProcedimentoEnum.Aguardando:
        this.buscarFilaAbertos()
        break;
      case FilaProcedimentoEnum.ProcedimentoAgendado:
        this.buscarFilaAgendados()
        break;
      case FilaProcedimentoEnum.Recusado:
        this.buscarFilaRecusados()
        break;

      default:
        this.buscarFilaAbertos()
        break;
    }
  }

  onChangeDataIni(ev) {
    this.setState
      ({ filtroData: { ...this.state.filtroData, dt_i: ev.target.value } },
        () => this.carregar(this.state.filtroSituacao.value)
      )
  }

  onChangeDataFin(ev) {
    this.setState
      ({ filtroData: { ...this.state.filtroData, dt_f: ev.target.value } },
        () => this.carregar(this.state.filtroSituacao.value)
      )
  }

  filtrar() {
    let lista = this.state.pacientes
    let hasFiltroPaciente = this.state.filtroPaciente && this.state.filtroPaciente != ''

    if (hasFiltroPaciente) {
      lista = this.state.pacientes.filter(x => {
        return x.dados.filter(d =>
          d.paciente.paciente.nome.toLowerCase().indexOf(this.state.filtroPaciente.toLowerCase()) >= 0
        ).length > 0
      });
    }

    // console.log(lista);
    this.setState({
      pacientesShow: lista
    })
  }

  importarTabelas() {
    this.setState({ modalImport: true })
  }


  render() {
    return (
      <React.Fragment>
        <div className="gb-cont-page">
          <CrudBar
            title="Gestão de Fila"
            breadcrumb={["Globalbrain", "Gestão de Fila"]}
            buttonText="Inserir Paciente"
            buttonAction={() => { this.openCadastro(null) }}
            noSearch={true}
            style={{ marginTop: "20px", marginBottom: "8px", maxWidth: "none" }}
          />

          <ModalComponent
            openModal={this.state.modalPacienteFila}
            closeModal={this.closeModal}
          >
            <AddPacienteFila
              item={this.state.editId}
              closeModal={this.closeModalReload}
              secretariaSelecionada={this.state.secretaria}
            />
          </ModalComponent>

          <ModalComponent
            openModal={this.state.modalDataFila}
            closeModal={this.closeModal}
            auto={true}
          >
            <DataFila
              item={this.state.editId}
              closeModal={this.closeModalReload}
            />
          </ModalComponent>

          <ModalComponent
            openModal={this.state.modalRecusa}
            closeModal={this.closeModal}
            auto={true}
          >
            <RecusaFila
              item={this.state.editId}
              closeModal={this.closeModalReload}
            />
          </ModalComponent>

          <ModalComponent
            openModal={this.state.modalDetalhe}
            closeModal={this.closeModal}
            auto={true}
          >
            <DadosFila
              item={this.state.editId}
            />
          </ModalComponent>

          <ModalComponent
            openModal={this.state.modalImport}
            closeModal={this.closeModal}
            // auto={true}
            newstyles={{
              content: {
                maxWidth: "800px"
              }
            }}
          >
            <ImportacaoTabelas />
          </ModalComponent>


          <div className="gb-page">
            {this.state.loading ? (<div className="text-center"><PreLoaderWidget /></div>) :

              <React.Fragment>
                <div className="row">
                  <div className="col-12 col-md-4 col-lg-3">
                    <div className="form-group">
                      <label>Situação</label><br />

                      <Select
                        placeholder="Selecione uma situação"
                        options={tiposFiltro}
                        value={this.state.filtroSituacao}
                        onChange={ev => {
                          this.setFiltroSituacao(ev);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            height: '31px',
                            'minHeight': '31px',
                            'fontSize': '11px',
                          }),
                          dropdownIndicator: base => ({
                            ...base,
                            padding: 4
                          }),
                          clearIndicator: base => ({
                            ...base,
                            padding: 4
                          }),
                        }}
                      />
                    </div>
                  </div>
                  {this.state.filtroSituacao.value !== FilaProcedimentoEnum.Aguardando &&
                    <div className="col-12 col-md-4 col-lg-4">
                      <label>Filtrar Periodo</label>
                      <Row>
                        <Col className="mr-1 pr-0">
                          <input
                            style={{ fontSize: '11px' }}
                            type="date"
                            className="form-control"
                            value={this.state.filtroData.dt_i}
                            onChange={(ev) => this.onChangeDataIni(ev)} />
                        </Col>
                        <Col className="ml-0 pl-0">
                          <input
                            style={{ fontSize: '11px' }}
                            type="date"
                            className="form-control"
                            value={this.state.filtroData.dt_f}
                            onChange={(ev) => this.onChangeDataFin(ev)} />
                        </Col>
                      </Row>
                    </div>
                  }

                  <div className="col-12 col-md-4 col-lg-3">
                    <label>
                      Buscar por Paciente
                    </label>
                    <input
                      type="text"
                      style={{ fontSize: '11px' }}
                      placeholder="filtrar por paciente"
                      onChange={(ev) => this.setState({ filtroPaciente: ev.target.value }, () => this.filtrar())}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-3 col-lg-2 d-flex align-items-center">
                    <CustomDropdown
                      dropToggle={
                        <React.Fragment>
                          <i className="gb-button icon-btn fa fa-cog drop-proc-icon"></i>

                        </React.Fragment>
                      }
                      dropMenu={
                        <React.Fragment>
                          <Link
                            to="#"
                            className="dropdown-item notify-item"
                            onClick={() => this.importarTabelas()}
                          >
                            <i className="fa fa-table mr-1"></i>Importar Tabelas SIGTAP
                          </Link>

                          <DropdownItem divider />
                          <Link
                            to="/filaRelatorioAbertos"
                            className="dropdown-item notify-item"
                          >
                            <i className="fa fa-file mr-1"></i>Relatório de Procedimentos demandados
                          </Link>

                          {/* <DropdownItem divider />
                          <Link
                            to="#"
                            className="dropdown-item notify-item"
                          >
                            <i className="fa fa-file mr-1"></i>Relatório de Procedimentos realizados
                          </Link> */}

                        </React.Fragment>
                      } />
                  </div>
                </div>
                <hr />

                {this.state.pacientesShow && this.state.pacientesShow.length > 0 ?
                  <div className="table-responsive">

                    {this.state.pacientesShow.map(
                      (proc, index1) => {
                        return (
                          <React.Fragment key={index1}>
                            <div className="gb-group" >{proc.procedimento}</div>

                            <table className="table gb-table">
                              <thead>
                                <tr>
                                  <th scope="col">Nº na fila</th>
                                  <th scope="col">Paciente</th>
                                  <th scope="col">Procedimento</th>
                                  <th scope="col">Status</th>
                                  <th scope="col">Fora Municipio</th>
                                  <th scope="col" style={{ minWidth: "92px" }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {proc.dados.map((item, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="text-center">{item.seq}</td>
                                      {/* <td scope="row" className="text-center">{index + 1}</td> */}
                                      <td className="text-center">{item.paciente.paciente.nome}</td>
                                      <td className="text-center">{item.procedimento.descricao}</td>
                                      <td className="text-center"
                                        style={{
                                          color: item.status === FilaProcedimentoEnum.ProcedimentoAgendado ? 'green' :
                                            item.status === FilaProcedimentoEnum.Recusado ? 'red' : 'orange'
                                        }}>{item.status}</td>
                                      <td className="text-center">{item.fora_municipio ? "Sim" : "Não"}</td>
                                      <td className="text-center">
                                        <a
                                          href="#"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.openDetalheModal(item)
                                          }}
                                          className="mr-1"
                                        >
                                          <img src={IconSearch} height={16} width={16} />
                                        </a>

                                        {
                                          item.status == FilaProcedimentoEnum.Aguardando && !item.viagemId &&
                                          <a
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              this.openCadastro(item)
                                            }}
                                            className="mr-1"
                                          >
                                            <img src={IconEdit} />
                                          </a>
                                        }
                                        {
                                          !item.viagemId &&
                                          [FilaProcedimentoEnum.Aguardando, FilaProcedimentoEnum.ProcedimentoAgendado].includes(item.status) &&
                                          <React.Fragment>
                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.openSetData(item)
                                              }}
                                              className="mr-1"
                                            >
                                              <img src={IconCalendar} />
                                            </a>

                                            <a
                                              href="#"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.openRecusaModal(item)
                                              }}
                                              className="mr-1"
                                            >
                                              <img src={IconTrash} style={{ height: "17px" }} />
                                            </a>
                                          </React.Fragment>
                                        }

                                      </td>
                                    </tr>
                                  )
                                })}
                              </tbody>
                            </table>
                          </React.Fragment>
                        )
                      }
                    )}

                  </div>
                  : <Row><h5 style={{ margin: "auto" }}>Não há pacientes ainda</h5></Row>
                }
              </React.Fragment>

            }

          </div>

        </div>
      </React.Fragment>
    );
  }
}

export default connect()(FilaProcedimentos);
